import React, { useState, useEffect } from 'react';
import { useSelector } from 'react-redux';
import Carousel from 'react-multi-carousel';
import 'react-multi-carousel/lib/styles.css';
import translate from '../../../i18n/translate';
import AddOutlinedIcon from '@material-ui/icons/AddOutlined';
import ClickAwayListener from '@material-ui/core/ClickAwayListener';
import { google, ics } from "calendar-link";
import { IGenerateLink } from "../../../interfaces";
import RollbarErrorTracking from "../../../utils/RollbarErrorTracking";
import Axios from "axios";
import moment from "moment";
import Moment from "moment-timezone";
import { AiFillApple } from "react-icons/ai";
import { AiOutlineGoogle } from "react-icons/ai";
import { SiMicrosoftoutlook } from "react-icons/si";
import ErrorModal from "./ErrorModal/ErrorModal";
import { twtLicenseMappingCheck } from "../../../helpers/twtHelpers";
import { twtLicenseMapper } from "../../../globalConstants";

const SelectSessions = (props: any) => {
  const allInfo = useSelector((state: any) => state);
  const [upcomingSessions, setUpcomingSessions] = useState([]);
  const [showAddToCalendar, setAddToCalendar] = useState("");
  const [joinClassroom, setJoinClassroom] = useState("");
  const [getErrorCode, setErrorCode] = useState("");
  let timeZone = Moment.tz.guess(true);

  const responsive = {
    superLargeDesktop: {
      breakpoint: { max: 4000, min: 3000 },
      items: 5,
    },
    desktop: {
      breakpoint: { max: 3000, min: 1024 },
      items: 3,
    },
    tablet: {
      breakpoint: { max: 1024, min: 464 },
      items: 2,
    },
    mobile: {
      breakpoint: { max: 464, min: 0 },
      items: 1,
    },
  };

  const handleClick = (calendarName: string, sessionId: string) => {
    let session = upcomingSessions.find((x: { id: string }) => x.id === sessionId);
    if (session) {
      let instructionUrl =
        allInfo.common.selectedLanguage === "EN"
          ? `${process.env.REACT_APP_GE_SUPPORT_URL}/EN-EN/solutions/one/twt`
          : `${process.env.REACT_APP_GE_SUPPORT_URL}/${allInfo.common.selectedLanguage}/solutions/one/twt`;

      let faqUrl = `${
        process.env.REACT_APP_ASSETS_URL
      }/halo/twt/twt_${allInfo.common.selectedLanguage.toLowerCase()}.pdf`;
      let instructionLink =
        calendarName === "google" ? `<a href='${instructionUrl}'>${instructionUrl}</a>` : instructionUrl;
      let faqLink = calendarName === "google" ? `<a href='${faqUrl}'>${faqUrl}</a>` : faqUrl;
      let twtLink =
        calendarName === "google"
          ? `<a href='${process.env.REACT_APP_TWT_URL}'>${process.env.REACT_APP_TWT_URL}</a>`
          : process.env.REACT_APP_TWT_URL;

      let calendarDescription = `Hello ${allInfo.peopleInformation.data.getpeopleInformation.username},
      \nHere are the details about your upcoming Talk With Teacher session:
      \nTopic : ${session["topic"] ? session["topic"]["name"] : "Topic name not available"}.
      \nDate : ${session["topic"] ? moment(session["startTime"]).format("DD MMMM YYYY") : "Not available"}
      \nStart Time : ${moment(session["startTime"]).format("hh:mm A")}
      \nPlease click : ${twtLink}
      \nWe strongly recommend that you read our Class Policy, ${instructionLink}, ${faqLink}, 
      \nEnjoy your Talk with the Teacher session
      \nThe Learnship Team`;

      const event: IGenerateLink = {
        title: "Talk with the Teacher Upcoming Session",
        description: calendarDescription,
        start: session["startTime"],
        duration: [1, "hour"],
        location: `${process.env.REACT_APP_TWT_URL}`,
      };

      if (calendarName === "outlook") {
        window.open(ics(event));
      } else if (calendarName === "apple") {
        window.open(ics(event));
      } else if (calendarName === "google") {
        window.open(google(event));
      }
    }
  };

  function getSessionsForTheDay() {
    let currentTime = Moment().tz(timeZone).valueOf();
    const filteredSessions = allInfo.getTWTSessions.data.filter((session: any) => {
      let timeToDisplay = Moment(session.startTime).tz(timeZone).add(10, "minutes").valueOf();
      let week = props.getWeek ? "currentWeek" : "nextWeek";
      let matchLevel = session?.classType.levelIds.find((x: any) => (x.cefr === props.userLevel ? true : false));
      let twtLicenseMapperCheck = twtLicenseMappingCheck(allInfo.peopleInformation.data.getpeopleInformation.license, twtLicenseMapper);
      if (
        matchLevel &&
        props.calendarDates[week].length > 0 &&
        currentTime < timeToDisplay &&
        twtLicenseMapperCheck.length > 0 &&
        twtLicenseMapperCheck[0].language === session?.classType.language.languageCode
      ) {
        let foundSession = props.calendarDates[week].find((x: any) => x.date === moment(session.startTime).format("DD"));
        if (foundSession) return session;
      }
    });

    let sessionsArray = filteredSessions.map((element: any) => {
      let enableJoinNowTime = Moment(element.startTime).tz(timeZone).valueOf();
      let showCardTime = Moment(element.startTime).tz(timeZone).add(10, "minutes").valueOf();
      return { ...element, isEnabled: showCardTime > currentTime && currentTime > enableJoinNowTime ? true : false };
    });
    sessionsArray.push({ id: "null", type: "View more sessions" });
    setUpcomingSessions(sessionsArray);
    props.loaderFlag(false);
  }

  useEffect(() => {
    if (
      !!!allInfo.getTWTSessions.isLoading &&
      !!!allInfo.getTWTSessions.isFailed &&
      !!allInfo.getTWTSessions.data &&
      !!!allInfo.common.isLoading &&
      !!!allInfo.common.data &&
      allInfo.peopleInformation.data
    ) {
      getSessionsForTheDay();
      sessionStorage.removeItem("twtJoinClassroom");
      const interval = setInterval(() => {
        getSessionsForTheDay();
      }, 5000);
      return () => {
        clearInterval(interval);
      };
    }
  }, [props.getWeek, allInfo]);

  const validateJoinSession = (response: any, sessionId: any) => {
    if (sessionStorage.getItem("twtJoinClassroom")) {
      setErrorCode("4");
    } else {
      const joinClassroom: any = window.open(response.data.url);
      joinClassroom.focus();
      sessionStorage.setItem("twtJoinClassroom", sessionId);
      const checkTimer: any = setInterval(() => {
        if (joinClassroom.closed) {
          sessionStorage.removeItem("twtJoinClassroom");
          clearInterval(checkTimer);
        }
      }, 1000);
    }
  };

  const joinSessionClick = async (sessionId: string) => {
    setJoinClassroom(sessionId);
    if (allInfo.getTWTToken.data.token) {
      const options = {
        headers: {
          Authorization: `Bearer ${allInfo.getTWTToken.data.token}`,
          "content-type": "application/json",
        },
      };
      await Axios.get(`${process.env.REACT_APP_TWT_QAROOMS}/api/twt-access-url?session=${sessionId}`, options).then((response) => {
        response.data.url ? validateJoinSession(response, sessionId) : setErrorCode(response.data.code);
      }).catch((error) => {
        RollbarErrorTracking.logErrorInRollbar(error.message, "error");
      });
      setJoinClassroom("");
    }
  };

  return (
    <>
      {(!props.isLimitReached) && 
        <Carousel
          deviceType={"desktop"}
          itemClass="image-item"
          transitionDuration={500}
          containerClass=""
          responsive={responsive}
        >
          {upcomingSessions.length > 0 &&
            upcomingSessions.map((session: any, index: number) => {
              if (upcomingSessions.length - 1 !== index) {
                return (
                  <div className={session?.isEnabled ? "activeCard" : "twtCard"}>
                    <div className="slider-content">
                      <div className="twt-text">
                        {translate("twt_topic")}: {session?.topic ? session?.topic.name : "Not assigned"}
                      </div>
                      <div className="twt-type">{session?.classType.name}</div>
                      {session?.topic ? (
                        <div className="twt-time">
                          {moment(session?.startTime).format("HH:mm")} to {moment(session?.endTime).format("HH:mm")}
                        </div>
                      ) : (
                        <div className="twt-time">Sessions not available</div>
                      )}
                      <div className="st-date">
                        {session?.topic ? moment(session?.startTime).format("DD MMMM") : "Not available"}
                      </div>
                    </div>
                    <div className="twt-calendar-container">
                      {session.isEnabled && (
                        <div
                          className="twt-joinNow"
                          onClick={() => (joinClassroom.length === 0 ? joinSessionClick(session.id) : "")}
                        >
                          <span className="twt-calendar-text">
                            {joinClassroom !== session.id ? "Join now" : "Joining ..."}
                          </span>
                        </div>
                      )}

                      {!session.isEnabled && (
                        <div className="twt-addToCalendar" onClick={() => setAddToCalendar(session.id)}>
                          <AddOutlinedIcon style={{ fontSize: 20 }}></AddOutlinedIcon>
                          <span className="twt-calendar-text">{translate("twt_add_to_calendar")}</span>
                        </div>
                      )}

                      {showAddToCalendar === session.id && (
                        <ClickAwayListener onClickAway={() => setAddToCalendar("")}>
                          <div className="calContent">
                            <div className="caltriangle-up">
                              <span className="caltriangle-inner"></span>
                            </div>
                            <SiMicrosoftoutlook
                              className="calendarLink"
                              onClick={() => handleClick("outlook", session.id)}
                            ></SiMicrosoftoutlook>
                            <AiFillApple
                              className="calendarLink"
                              onClick={() => handleClick("apple", session.id)}
                            ></AiFillApple>
                            <AiOutlineGoogle
                              className="calendarLink"
                              onClick={() => handleClick("google", session.id)}
                            ></AiOutlineGoogle>
                          </div>
                        </ClickAwayListener>
                      )}
                    </div>
                  </div>
                );
              } else {
                return (
                  <div className="viewSchedule">
                    <p>{translate("twt_view_schedule_title")}</p>
                    <div className="viewMore" onClick={props.executeScroll}>
                      {translate("twt_view_more")}
                    </div>
                  </div>
                );
              }
            })}
        </Carousel>
      }
      {getErrorCode.length > 0 && <ErrorModal errorCode={getErrorCode} setErrorCode={setErrorCode}></ErrorModal>}
    </>
  );
};

export default SelectSessions;
